import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTabs,{staticClass:"bg-white mb-5 rounded pl-0",attrs:{"value":_vm.currentTabIndex,"background-color":"transparent"},on:{"change":_vm.changeTab}},_vm._l((_vm.tabs),function(tabItem){return _c(VTab,{key:tabItem.index,attrs:{"tabindex":tabItem.index,"disabled":_vm.disableTabs.find(x => x.i == tabItem.index).disabled},on:{"click":function($event){return _vm.loadRoute(tabItem.routeName)}}},[_vm._v(_vm._s(tabItem.label))])}),1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }